import { defineStore } from "pinia";

type ScrollDirection = "up" | "down" | "";

interface ScrollState {
  direction: ScrollDirection;
  isTop: boolean;
  isBottom: boolean;
  scrollTop: number;
}

export const useScrollStore = defineStore("scroll", {
  state: (): ScrollState => ({
    direction: "",
    isTop: true,
    isBottom: false,
    scrollTop: 0,
  }),
  getters: {
    isUp: (state): boolean => state.direction === "up",
    isDown: (state): boolean => state.direction === "down",
    isAtTop: (state): boolean => state.isTop,
    isAtBottom: (state): boolean => state.isBottom,
    getScrollTop: (state): number => state.scrollTop,
  },
  actions: {
    resetDirection(): void {
      this.direction = "";
    },
    setDirection(direction: ScrollDirection): void {
      this.direction = direction;
    },
    setIsTop(isTop: boolean): void {
      this.isTop = isTop;
    },
    setScrollTop(scrollTop: number): void {
      this.scrollTop = scrollTop;
    },
    setIsBottom(isBottom: boolean): void {
      this.isBottom = isBottom;
    },
  },
});
